export const environment = {
    production: false,
    env: {
        name: "DEMO",
        banner: "Demo Environment"
    },
    logLevel: 'INFO',
    apiServer:  {
        webSocketlUrl: "wss://portalserver-demo.acimobills.com/portal",
        portalUrl: "https://portalserver-demo.acimobills.com/portal/api",
        authServerUrl: "https://portalserver-demo.acimobills.com/auth/api",
        rtpnUrl: "https://demo.walletron.com/rtpn/api"         
    },
    appSetting: {
    },
    brandMigration: {
        sourceRegions:  ["uat", "client2prod", "mbprod", "mobills2prod", "wuprod"],
        targetRegions: ["demo"]
    }
};